module.exports = __webpack_public_path__ + "static/media/tickets-grey.bc34964a.svg";